import React, { useEffect, useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setQuestionAnswerList } from '../../system/redux/reducers/surveyReducer';

export default function SurveyMultiSelectDropdown(props) {
    const dispatch = useDispatch();
    const [question, setQuestion] = useState(props.question);
    const [dropdownItems, setDropdownItems] = useState(question.optionList);

    const [selectedValues, setSelectedValues] = useState();
    
    const handleChangeMultiple = (event) => {
        console.log(event.target);
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
            if (options[i].selected) {
                value.push(parseInt(options[i].value));
            }
        }

        if (question.maxAnswerAllowed !== -1) {
            if (value.length <= question.maxAnswerAllowed) {
                setSelectedValues(value);
            }
        } else {
            setSelectedValues(value);
        }
    };

    useEffect(()=>{
        console.log(selectedValues);
        var payload = {
            id: question.id
        };

        if(selectedValues && selectedValues?.length > 0){
            payload = {
                id: question.id, // Use questionId
                answerList: [{
                    // Set optionIdList to all selected options
                    optionIdList:selectedValues
            }],
            };
        }

        console.log(payload);
        dispatch(setQuestionAnswerList(payload));
    },[selectedValues])

    return (
        <div>
            <FormControl sx={{ m: 1, minWidth: 120, maxWidth: 300 }}>
                <Select
                    multiple
                    native
                    value={selectedValues}
                    onChange={handleChangeMultiple}
                    label="Select multiple"
                    inputProps={{
                        id: "question-id-" + question.id + "-option-id-0",
                        className: "question-id-" + question.id + "-option-id-0",
                        name: "questionList[" + question.questionSequenceNo + "].answerList[0].questionOptionId"
                    }}
                >
                    {dropdownItems.map((item, index) => (
                        <option key={item.dynamicOptionId} value={item.id}>
                            {item.name}
                        </option>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}
